import { Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { RegisterEmailForm } from "./register-email-form";

export const Register = () => {
  const { t } = useTranslation();
  return (
    <VStack w="full" flex={1} justify="center" spacing={0} py={2}>
      <VStack w="full" maxW="500px" spacing={0} px={4}>
        <Text
          fontFamily="'Barlow Condensed', sans-serif"
          fontSize="28px"
          fontWeight={700}
          color="#13192E"
          textAlign="center"
          mb={5}
        >
          {t("register.createAccount")}
        </Text>

        <RegisterEmailForm />
      </VStack>
    </VStack>
  );
};
